export default __webpack_public_path__ + "static/media/navy_double_arrow_left.9d33bc9e.svg";